import * as React from 'react';

import { TabUnderlineSettings } from '../../../interfaces';

import { Container, Counter } from './tabUnderline.styled';
import { TabUnderlineProps } from './tabUnderline.types';

export const TabUnderline: React.FC<TabUnderlineProps> = (props: TabUnderlineProps): JSX.Element => {
  const { tabSettings, className }: TabUnderlineProps = props;
  const {
    label,
    externalUrl,
    internalPath,
    action,
    name,
    isActive = false,
    counterValue,
    withTransparentUnderline = false
  }: TabUnderlineSettings = tabSettings;

  return (
    <Container
      label={label}
      externalUrl={externalUrl}
      internalPath={internalPath}
      action={action}
      name={name}
      $isActive={isActive}
      $withTransparentUnderline={withTransparentUnderline}
      className={className}
    >
      {label}
      {!!counterValue && <Counter>{counterValue}</Counter>}
    </Container>
  );
};
